import '.c{display:flex;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.bq{align-items:flex-start;}.ssr-plugin'
import '.k{gap:1.5rem;}.ssr-plugin'
import '.c9{background:var(--palette-white);}.ssr-plugin'
import '.y{flex-direction:row;}.ssr-plugin'
import '.ci{justify-content:flex-start;}.ssr-plugin'
import '.fw{gap:2.5rem;}.ssr-plugin'
import '.cp{flex-wrap:wrap;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="c g bq k c9"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="c y ci bq fw cp"
      >
        {items.map((item, index) => (
          <div className="c g h al"
            key={index}
          >
            {/* Total Number */}
            <Title.H1
              style={{
                fontSize: '4rem',
                fontWeight: '700',
                lineHeight: '100%',
                margin: 0,
                color: 'var(--brand-secondary)',
                fontFamily: 'FunnelDisplay',
              }}
            >
              {item.total}
            </Title.H1>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
